import { swRequest } from "@sourcewhale/core";

export const getCurrencies = (opts = {}) =>
  swRequest(
    {
      path: "/api/currencies/get_all",
      method: "GET",
    },
    opts,
  );
